(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobx"), require("mobxReact"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("sbCommonLib", ["React", "mobx", "mobxReact", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["sbCommonLib"] = factory(require("React"), require("mobx"), require("mobxReact"), require("ReactDOM"));
	else
		root["sbCommonLib"] = factory(root["React"], root["mobx"], root["mobxReact"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__12__) {
return 